<template>
  <div>
      <v-overlay :value="locationLoader">
        <v-progress-circular color='white' indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon
          v-if="isSmallSize"
          @click="getLocation"
          class="loactionIconSmall d-inline for-mobile-location"
          v-on="on"
          medium
        >mdi-crosshairs-gps</v-icon>
        <v-icon
          v-else
          @click="getLocation"
          class="loactionIcon d-inline for-mobile-location"
          v-on="on"
          medium
        >mdi-crosshairs-gps</v-icon>
      </template>
      <span>Locate Yourself</span>
    </v-tooltip>
    </div>
</template>
<script>
import CONSTANTS from '../../../config/constant'
import ENV_CONSTANTS from '../../../config/envVariables'
export default {
  name: 'Geolocationmarker',
  data: () => ({
    isLocationAllowed: true,
    googleApiGeoEndpoint: ENV_CONSTANTS.GOOGLE_API_GEO_ENDPOINT,
    locationData: {},
    isStatePresent: false,
    isCountyPresent: false,
    isJurisdictionPresent: false,
    isTownshipPresent: false,
    locationCountryName: '',
    currentCountryName: '',
    locationStateName: '',
    locationCountyName: '',
    locationJurisdictionName: '',
    locationTownshipName: '',
    locationLoader: false,
    geoLocationkey: ENV_CONSTANTS.GEO_LOCATION_KEY,
    formData: {}
  }),
  methods: {
    getLocation () {
      this.$getLocation({})
        .then(location => {
          this.locationLoader = true
          const { lng, lat } = location
          if (lng) {
            this.locationData.location_longitude = lng
          }
          if (lat) {
            this.locationData.location_latitude = lat
          }
          // Google callback
          this.getLocationAddressFromCoordinates()
        })
        .catch(errorMessage => {
          this.locationLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(errorMessage)
          this.$globalStates.notification.init_notifications = false
        })
    },
    getLocationAutomatically () {
      this.$getLocation({})
        .then(location => {
          this.locationLoader = true
          const { lng, lat } = location
          if (lng) {
            this.locationData.location_longitude = lng
          }
          if (lat) {
            this.locationData.location_latitude = lat
          }
          // Google callback
          this.getCurrentLocationAutomatically()
        })
        .catch(errorMessage => {
        })
    },
    generateProfileSectionData (metadata) {
      if (metadata.adoptionLevel === '1') {
        return {
          entitySeal: metadata.stateLogo,
          entityName: metadata.stateName,
          entityAbbreviation: metadata.countryAbbr,
          jurisdictionUrl: metadata.stateUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.stateProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: metadata.stateAbbr,
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '2') {
        return {
          entitySeal: metadata.countyLogo,
          entityName: metadata.countyName,
          entityAbbreviation: metadata.stateAbbr,
          jurisdictionUrl: metadata.countyUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.countyProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '3') {
        return {
          entitySeal: metadata.jurisdictionLogo,
          entityName: metadata.jurisdictionName,
          entityAbbreviation: metadata.stateAbbr,
          jurisdictionUrl: metadata.jurisdictionUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.jurisdictionProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '4') {
        return {
          entitySeal: metadata.townshipLogo,
          entityName: metadata.townshipName,
          entityAbbreviation: metadata.stateAbbr,
          jurisdictionUrl: metadata.townshipUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.townshipProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          countyName: metadata.countyName,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      }
    },
    /**
* Google API call for location based on longtitude and latitude
* @param {Object}
* @returns {Void}
*/
    getLocationAddressFromCoordinates () {
      this.$globalStates.notification.init_notifications = false
      const url = `${this.googleApiGeoEndpoint}latlng=${this.locationData.location_latitude},${this.locationData.location_longitude}&key=${this.geoLocationkey}`
      this.$axios.get(url, { withCredentials: false }).then(
        response => {
          const { results, status } = response.data
          const errorMessage = response.data.error_message
          this.locationCountryName = response.data.results[0].address_components
          this.locationCountryName.map(e => {
            if (e.types?.includes('country')) {
              if (e.short_name === CONSTANTS.DEFAULT_COUNTRY_NAME) {
                this.$router.push({ name: 'Home' })
              } else {
                this.getCountryDetails(e.long_name)
              }
            }
          })
          if (results && results.length) {
            for (let locationItem of results) {
              if (locationItem.types[0] === 'administrative_area_level_2') {
                const { long_name: locationCountyName } = locationItem.address_components[0]
                this.isCountyPresent = true
                this.locationCountyName = locationCountyName.replace(' County', '')
              }
              if (locationItem.types[0] === 'administrative_area_level_1') {
                const { long_name: stateName } = locationItem.address_components[0]
                this.isStatePresent = true
                this.locationStateName = stateName
              }
              if (locationItem.types[0] === 'locality') {
                const { long_name: locationJurisdictionName } = locationItem.address_components[0]
                this.isJurisdictionPresent = true
                this.locationJurisdictionName = locationJurisdictionName
              }
              if (locationItem.types[0] === 'administrative_area_level_3') {
                const { long_name: locationTownshipName } = locationItem.address_components[0]
                this.isTownshipPresent = true
                this.locationTownshipName = locationTownshipName
              }
            }
            /**
             * Extract the following fields from Google API response
             * administrative_area_level_1 => shows state
             * administrative_area_level_2 => shows county
             * locality => shows jurisdiction
             * administrative_area_level_3 => shows township
             * Working logic:-
             * Step 1: check for jurisdiction
             *    If "locality" present in Google api response
             *    then check it's presence in adoption DB it
             *    If match found redirect to jurisdiction profile
             * Step 2: check for township
             *    If "administrative_area_level_3" present in Google api response
             *    then check it's presence in adoption DB it
             *    If match found redirect to township profile
            *  Step 3: check for county
             *    If "administrative_area_level_2" present in Google api response
             *    then check it's presence in adoption DB it
             *    If match found redirect to county profile
             * Step 4: check for state (rarely use)
             *    If "administrative_area_level_1" present in Google api response
             *    then check it's presence in adoption DB it
             *    If match found redirect to state profile
             */
            // identify the redirection
            // check if jurisdiction present in adoption DB
            const checkData = {
              stateName: this.locationStateName,
              jurisdictionName: this.locationJurisdictionName,
              locationLevel: 3
            }
            new Promise((resolve, reject) => {
              this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
            }).then((tokenData) => {
              let tokens = tokenData.data
              this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
                new Promise((resolve, reject) => {
                  this.$store.dispatch('FESearchModule/isLocationPresent', {
                    resolve,
                    reject,
                    checkData
                  })
                })
                  .then(responseData => {
                    // if found set form data end send for jurisdiction page redirection
                    if (responseData.isLocationPresent === 2) {
                      this.formData = {
                        stateName: this.locationStateName,
                        jurisdictionName: this.locationJurisdictionName
                      }
                      this.redirectControl()
                    }
                    if (responseData.isLocationPresent === 1) {
                      // check if township present in adoption DB
                      const checkData = {
                        stateName: this.locationStateName,
                        countyName: this.locationCountyName,
                        townshipName: this.locationTownshipName,
                        locationLevel: 4
                      }
                      new Promise((resolve, reject) => {
                        this.$store.dispatch('FESearchModule/isLocationPresent', {
                          resolve,
                          reject,
                          checkData
                        })
                      })
                        .then(responseData => {
                          // if found set form data end send for township page redirection
                          if (responseData.isLocationPresent === 2) {
                            this.formData = {
                              stateName: this.locationStateName,
                              countyName: this.locationCountyName,
                              townshipName: this.locationTownshipName
                            }
                            this.redirectControl()
                          }
                          if (responseData.isLocationPresent === 1) {
                            // check if county present in adoption DB
                            const checkData = {
                              stateName: this.locationStateName,
                              countyName: this.locationCountyName,
                              locationLevel: 2
                            }
                            new Promise((resolve, reject) => {
                              this.$store.dispatch('FESearchModule/isLocationPresent', {
                                resolve,
                                reject,
                                checkData
                              })
                            })
                              .then(responseData => {
                                // if found set form data end send for county page redirection
                                if (responseData.isLocationPresent === 2) {
                                  this.formData = {
                                    stateName: this.locationStateName,
                                    countyName: this.locationCountyName
                                  }
                                  this.redirectControl()
                                }
                                if (responseData.isLocationPresent === 1) {
                                  const checkData = {
                                    stateName: this.locationStateName,
                                    locationLevel: 1
                                  }
                                  new Promise((resolve, reject) => {
                                    this.$store.dispatch('FESearchModule/isLocationPresent', {
                                      resolve,
                                      reject,
                                      checkData
                                    })
                                  })
                                    .then(responseData => {
                                      // if found set form data end send for state page redirection
                                      if (responseData.isLocationPresent === 2) {
                                        this.formData = {
                                          stateName: this.locationStateName
                                        }
                                        this.redirectControl()
                                      }
                                      if (responseData.isLocationPresent === 1) {
                                        this.formData = {}
                                        this.locationLoader = false
                                      }
                                    })
                                    .catch(response => {
                                      this.formData = {}
                                    })
                                }
                              })
                              .catch(response => {
                                this.formData = {}
                              })
                          }
                        })
                        .catch(response => {
                          this.formData = {}
                          this.locationLoader = false
                          this.$globalStates.notification.type = 'error'
                          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(CONSTANTS.LOCATION_NOT_FOUND)
                          this.$globalStates.notification.init_notifications = true
                        })
                    }
                  })
                  .catch(response => {
                    // ToDo final catch
                    this.formData = {}
                    this.locationLoader = false
                    this.$globalStates.notification.type = 'error'
                    this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(CONSTANTS.LOCATION_NOT_FOUND)
                    this.$globalStates.notification.init_notifications = true
                  })
              }).catch()
            }).catch()
          }
          /**
          * errorMessage is provided for the following status codes in the status field of the response
          * ZERO_RESULTS, OVER_DAILY_LIMIT, OVER_QUERY_LIMIT, REQUEST_DENIED, INVALID_REQUEST, UNKNOWN_ERROR
          */
          if (status !== 'OK' && errorMessage) {
            this.locationLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(errorMessage)
            this.$globalStates.notification.init_notifications = true
          }
        },
        error => {
          this.locationLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(error)
          this.$globalStates.notification.init_notifications = false
        }
      )
    },
    getCountryDetails (countryName) {
      this.$axios.get(`/public/api/v1/country/adoption`, {
        params: {
          countryName: countryName
        }
      }).then(responseData => {
        const { data } = responseData
        if (data.length > 0 && data[0].adoption !== ' ') {
          this.$router.push({ name: 'WorldCodeAdoption', params: { countryName: countryName.split(' ').join('-').toLowerCase(), locateMe: true } })
        } else {
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(CONSTANTS.LOCATION_NOT_FOUND)
          this.$globalStates.notification.init_notifications = true
        }
      })
        .catch(({ response }) => {
        })
    },
    getCurrentLocationAutomatically () {
      this.$globalStates.notification.init_notifications = false
      const url = `${this.googleApiGeoEndpoint}latlng=${this.locationData.location_latitude},${this.locationData.location_longitude}&key=${this.geoLocationkey}`
      this.$axios.get(url, { withCredentials: false }).then(
        response => {
          const { results, status } = response.data
          const errorMessage = response.data.error_message
          this.locationCountryName = response.data.results[0].address_components
          if (results && results.length) {
            this.locationLoader = false
            this.locationCountryName.map(e => {
              if (e.types?.includes('country')) {
                this.currentCountryName = e.long_name
                if (e.short_name === CONSTANTS.DEFAULT_COUNTRY_NAME) {
                  this.$router.push({ name: 'Home', params: { locateMe: true, pageId: true } })
                } else if (e.short_name !== CONSTANTS.DEFAULT_COUNTRY_NAME) {
                  this.$router.push({ name: 'GlobalCodes', params: { locateMe: true, pageId: true } })
                }
              }
            })
          }
          if (status !== 'OK' && errorMessage) {
            this.locationLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(errorMessage)
            this.$globalStates.notification.init_notifications = true
          }
        },
        error => {
          this.locationLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(error)
          this.$globalStates.notification.init_notifications = false
        }
      )
    },
    redirectControl () {
      const formData = this.formData
      new Promise((resolve, reject) => {
        this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
      }).then((tokenData) => {
        let tokens = tokenData.data
        this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
          new Promise((resolve, reject) => {
            this.$store.dispatch('FESearchModule/fetchBooksOnLoad', {
              resolve,
              reject,
              formData
            })
          })
            .then(responseData => {
              let responseObject = this.generateProfileSectionData(responseData.metaList)
              this.$store.commit('FEMapModule/setMetaData', responseObject)
              this.$emit('dataLoader', false)
              this.$store.commit('FESearchModule/setCheckBookMarkSearchAPI', true)
              this.locationLoader = false
              if (parseInt(responseData.metaList.adoptionLevel) === CONSTANTS.STATE_LEVEL) {
                this.$router.push({ name: 'StateCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else if (parseInt(responseData.metaList.adoptionLevel) === CONSTANTS.COUNTY_LEVEL) {
                this.$router.push({ name: 'CountyCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), countyName: this.locationCountyName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else if (parseInt(responseData.metaList.adoptionLevel) === CONSTANTS.JURISDICTION_LEVEL) {
                this.$router.push({ name: 'JurisdictionCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), jurisdictionName: this.locationJurisdictionName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else if (parseInt(responseData.metaList.adoptionLevel) === CONSTANTS.TOWNSHIP_LEVEL) {
                this.$router.push({ name: 'TownshipCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), countyName: this.locationCountyName.replace(/\s+/g, '-'), townshipName: this.locationTownshipName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else {
                this.$globalStates.notification.type = 'error'
                this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(CONSTANTS.LOCATION_NOT_FOUND)
                this.$globalStates.notification.init_notifications = true
              }
            })
            .catch(response => {
              let responseObject = this.generateProfileSectionData(response.metaList)
              this.$store.commit('FEMapModule/setMetaData', responseObject)
              this.$emit('dataLoader', false)
              this.locationLoader = false
              if (parseInt(response.metaList.adoptionLevel) === CONSTANTS.STATE_LEVEL) {
                this.$router.push({ name: 'StateCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), locateMe: true } })
              } else if (parseInt(response.metaList.adoptionLevel) === CONSTANTS.COUNTY_LEVEL) {
                this.$router.push({ name: 'CountyCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), countyName: this.locationCountyName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else if (parseInt(response.metaList.adoptionLevel) === CONSTANTS.JURISDICTION_LEVEL) {
                this.$router.push({ name: 'JurisdictionCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), jurisdictionName: this.locationJurisdictionName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else if (parseInt(response.metaList.adoptionLevel) === CONSTANTS.TOWNSHIP_LEVEL) {
                this.$router.push({ name: 'TownshipCodeAdoption', params: { stateName: this.locationStateName.replace(/\s+/g, '-'), countyName: this.locationCountyName.replace(/\s+/g, '-'), townshipName: this.locationTownshipName.replace(/\s+/g, '-'), locateMe: true, pageId: true } })
              } else {
                this.$globalStates.notification.type = 'error'
                this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(CONSTANTS.LOCATION_NOT_FOUND)
                this.$globalStates.notification.init_notifications = true
              }
            })
        }).catch()
      }).catch()
    }
  },
  props: {
    isSmallSize: Boolean
  },
  mounted () {
    this.isLocationAllowed = this.$geoLocationAvailable()
    if (!this.$route.params.pageId && !this.$route.params.locateMe && this.$route.name === 'Home') {
      this.isLocationAllowed = this.getLocationAutomatically()
    }
    if (!this.$route.params.pageId && !this.$route.params.locateMe && this.$route.name === 'ICodeMap') {
      this.isLocationAllowed = this.getLocationAutomatically()
    }
    if (!this.$route.params.pageId && !this.$route.params.locateMe && this.$route.name === 'GlobalCodes') {
      this.isLocationAllowed = this.getLocationAutomatically()
    }
  },
  created () {
  }
}
</script>
